export default __webpack_public_path__ + "assets/882e12c82547a7636ef973afbe55d054.woff";